import styled from 'styled-components'

import { headerHeight } from '../../../../../../constants'

export const Body = styled.div`
  background: white;
  max-height: calc(100vh - ${headerHeight});
  top: ${headerHeight};
  overflow-y: auto;
  position: sticky;

  /* Hide scrollbars */
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
`
